import React, { PropsWithChildren, useState } from 'react';
import { Chip, ChipProps, Tooltip } from '@mui/material';
import cx from 'classnames';
import classes from './ChipWithCopy.module.scss';
import Typography from 'new/elements/TypographySupport/TypographySupport';
import { fallbackCopyTextToClipboard } from 'js/lib/MiscUtils';

interface ChipWithCopyProps {
  toCopy?: string;
  chipProps?: ChipProps;
  tooltipTitle?: string;
  tooltipCopiedTitle?: string;
  mode?: 'default' | 'light';
  'data-testid'?: string;
  placement?: 'bottom-start' | 'top-start' | 'bottom-end' | 'top-end';
}

type Props = PropsWithChildren<ChipWithCopyProps>;

export const ChipWithCopy = (props: Props) => {
  const {
    children,
    toCopy,
    chipProps = {},
    tooltipTitle = 'Click to copy ID',
    tooltipCopiedTitle = 'ID Copied',
    mode = 'default',
    'data-testid': dataTestId,
    placement = 'bottom-start',
  } = props;
  const [isCopied, setCopied] = useState(false);
  const handleIDCopy = async (e: any) => {
    e.stopPropagation();

    try {
      await fallbackCopyTextToClipboard(toCopy || children);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch (error) {
      console.error('An error occurred at ChipWithCopy component:', error);
    }
  };

  return (
    <Tooltip
      arrow
      leaveDelay={600}
      aria-label="chip-with-copy"
      title={isCopied ? tooltipCopiedTitle : tooltipTitle}
      placement={placement}
    >
      {mode === 'light' ? (
        <div onClick={handleIDCopy}>{children}</div>
      ) : (
        <Chip
          {...chipProps}
          size="small"
          variant="rounded"
          className={cx(classes.chip, { [classes.copied]: isCopied })}
          onClick={handleIDCopy}
          label={
            <Typography variant="caption" className={classes.chipText}>
              {children}
            </Typography>
          }
          data-testid={dataTestId}
        />
      )}
    </Tooltip>
  );
};
